import { mapFirstImage } from '../DataTypes/imageMapper';

export const mapArticleMedia = ({
	content,
	settings,
}: {
	content: {
		contentType: 'articleMedia';
		id: string;
		properties: {
			image: Umbraco.Image[];
			caption?: string | null;
			altText?: string | null;
		};
	};
	settings: {
		properties: {
			disableCropping: boolean;
		};
	};
}): Content.ContentModule => {
	return {
		documentType: content?.contentType,
		content: {
			properties: {
				image: mapFirstImage(content?.properties.image),
				caption: content?.properties?.caption ?? null,
				altText: content?.properties?.altText ?? null,
			},
		},
		settings: {
			properties: settings?.properties ?? null,
		},
	};
};
